import { render } from "./XeroInvoiceLink.vue?vue&type=template&id=604083da"
import script from "./XeroInvoiceLink.vue?vue&type=script&lang=js"
export * from "./XeroInvoiceLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__